export const getIconMaterialFromExtension = (extension) => {
  extension = extension.toLowerCase();
  if (extension == "doc" || extension == "docx") {
    return "mdi-file-word text-primary";
  } else if (
    extension == "xls" ||
    extension == "xlsx" ||
    extension == "csv"
  ) {
    return "mdi-file-excel text-success";
  } else if (extension == "pdf") {
    return "mdi-file-pdf text-danger";
  } else if (extension == "zip") {
    return "mdi-folder-zip text-warning";
  } else if (extension == "doc" || extension == "docx") {
    return "mdi-file-document text-primary";
  } else if (extension == "ppt" || extension == "pptx") {
    return "mdi-file-powerpoint text-primary";
  } else if (extension == "mp4" || extension == "mov" || extension == "avi") {
    return "mdi-file-video text-primary";
  } else if (extension == "dwg" || extension == "kmz") {
    return "mdi-file text-primary";
  }
  else if (
    extension == "jpg" ||
    extension == "jpeg" ||
    extension == "png" ||
    extension == "bmp"
  ) {
    return "mdi-image-area text-danger";
  } else {
    return "mdi-file";
  }
}

export const flattenFolders = (folders) => {
  let result = [];
  function flatten(folder) {
    if (!folder.documents && folder.status) {
      result.push({ id: folder.id, name: folder.name, business_unit: folder.business_unit, is_pre_project_ready: folder.is_pre_project_ready });
    }
    if (folder.children) {
      folder.children.forEach(flatten);
    }
  }

  folders.forEach(flatten);
  return result;
}

export const setFileFolderToChildrenFolder = (folders, filters) => {
  function setFileFolderToChildrenFolder(folder) {
    if (folder.folder_document_types?.length) {
      let documentsFolder = []
      folder.folder_document_types.forEach((document_type) => {
        document_type.documents.forEach((document) => {
          if (filters.document_type_filter) {
            //Aplicar filtro por coincidencia de texto
            if (document_type?.document_type?.name.toLowerCase().includes(filters.document_type_filter.toLowerCase()) && document.status) {
              documentsFolder.push({ ...document, name: document.file_name, document_type: { ...document_type.document_type }, upload: true, is_cubicacion: document_type.is_cubicacion });
            }
          } else if (document.status) {
            if (filters.assigned_area_filter) {
              //Aplicar filtro por coincidencia de texto
              if (document_type?.document_type?.assigned_area.name.toLowerCase().includes(filters.assigned_area_filter.toLowerCase()) && document.status) {
                documentsFolder.push({ ...document, name: document.file_name, document_type: { ...document_type.document_type }, upload: true, is_cubicacion: document_type.is_cubicacion });
              }
            } else {
              documentsFolder.push({ ...document, name: document.file_name, document_type: { ...document_type.document_type }, upload: true, is_cubicacion: document_type.is_cubicacion });
            }
          }

        })
        if ((!document_type.documents.length || document_type.documents.every(document => !document.status)) && document_type.required) {
          if (!filters.document_type_filter || (filters.document_type_filter && document_type.document_type.name.toLowerCase().includes(filters.document_type_filter.toLowerCase()))) {
            if (!filters.assigned_area_filter || (filters.assigned_area_filter && document_type.document_type.assigned_area.name.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().includes(filters.assigned_area_filter.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()))) {
              if (!documentsFolder.some(document => document_type?.document_type?.name === document?.document_type?.name)) {
                documentsFolder.push({
                  name: null,
                  document_type: { ...document_type.document_type },
                  folder_name: folder.name,
                  folder_document_type_id: document_type.id,
                  pre_project_locked: document_type.pre_project_locked,
                  is_cubicacion: document_type.is_cubicacion,
                  upload: false,
                  url: null,
                  extension: null,
                  comment: null,
                  created_at: null,
                  updated_at: null,
                  required: document_type.required
                });
              }
            }
          }
        }
      });
      if (documentsFolder.length) {
        folder.documents_count = documentsFolder.filter(document => document.upload).length;
        folder.children.push({
          id: `${new Date().getTime() + Math.floor(Math.random() * 1000)}`,
          children: null,
          //Sort de los documentos colocando primero los que tengan upload = true
          documents: sortDocumentsFolder(documentsFolder),
          status: true
        })
      }
    }
    if (folder.children?.length) {
      folder.children.forEach((child) => {
        setFileFolderToChildrenFolder(child);
      });
      try {
        folder.children = folder.children
          .filter(child => child.status)
          .sort((a, b) => a.children ? 1 : -1);

      } catch (error) {
        console.log(error);
      }
    }
  }
  folders.forEach((folder) => {
    setFileFolderToChildrenFolder(folder);
  });
  return folders
    .filter(folder => folder.status)
    .sort((a, b) => a.children ? 1 : -1);
};

export const filterDeletedFolders = (folders) => {
  function filterDeletedFolders(folder) {
    if (folder.children?.length) {
      folder.children.forEach((child) => {
        filterDeletedFolders(child);
      })
      try {
        //Haz un sort de los hijos por el name
        folder.children = folder.children.map(child => {
          return {
            ...child,
            parent: folder,
          }
        }).filter(child => child.status);
      } catch (error) {
        console.log(folder.children);
      }
    }
  }
  folders.forEach((folder) => {
    filterDeletedFolders(folder);
  });
  return folders.filter(folder => folder.status);
};

export const setDocumentsTypesFromFolders = (folders) => {
  let result = []
  function setDocumentsTypesFromFolder(folder) {
    if (folder.folder_document_types?.length) {
      folder.folder_document_types.forEach((document_type) => {
        if (!result.some(item => item.name == document_type?.document_type?.name)) {
          result.push({ ...document_type.document_type });
        }
      });
    }
    if (folder.children?.length) {
      folder.children.forEach((child) => {
        setDocumentsTypesFromFolder(child);
      });
    }
  }
  folders.forEach((folder) => {
    setDocumentsTypesFromFolder(folder);
  });
  return result;
};

function sortDocumentsFolder(documents) {
  return documents.sort((a, b) => {
    const regexNumber = /^\d/;
    const regexAlphaNumeric = /^[a-zA-Z]+\d/;
    const regexExtractNumbers = /\d+/g;

    const aName = a?.document_type?.name;
    const bName = b?.document_type?.name;


    const aNumbers = aName ? aName.match(regexExtractNumbers) : [];
    const bNumbers = bName ? bName.match(regexExtractNumbers) : [];

    // Regla 1: Si ambos comienzan con número
    if (regexNumber.test(aName) && regexNumber.test(bName)) {
      return parseInt(aName) - parseInt(bName);
    }
    // Regla 3: Si ambos son alfanuméricos
    else if (regexAlphaNumeric.test(aName) && regexAlphaNumeric.test(bName)) {
      const alphaA = aName.match(/[a-zA-Z]+/)[0];
      const alphaB = bName.match(/[a-zA-Z]+/)[0];
      if (alphaA !== alphaB) {
        return alphaA.localeCompare(alphaB);
      } else {
        for (let i = 0; i < Math.min(aNumbers.length, bNumbers.length); i++) {
          const numA = parseInt(aNumbers[i]);
          const numB = parseInt(bNumbers[i]);
          if (numA !== numB) {
            return numA - numB;
          }
        }
        return aNumbers.length - bNumbers.length;
      }
    }
    // Si uno comienza con número y el otro no
    else if (regexNumber.test(aName)) {
      return -1;
    } else if (regexNumber.test(bName)) {
      return 1;
    }
    // Regla 2: Orden alfabético
    else if (!aNumbers && !bNumbers) {
      return aName.localeCompare(bName);
    }
    // Ordenar alfanuméricamente con números ascendentes
    else {
      return aName.localeCompare(bName);
    }
  });
}